<template>
  <div class="stats-container mb-3">
    <div class="slider-container">
      <el-slider
        class="mb-4"
        @change="onTimeRangeSelected"
        @update:model-value="value => sliderValue = value"
        :model-value="sliderValue"
        :marks="marks"
        :show-tooltip="false"
        :step="33.33"
      />
    </div>
    <div class="content-container">
      <div class="metric-text mb-1" :span="24">
        <span class="group-name">Repetitions</span>
      </div>
      <el-row
          :gutter="16"
          class="mb-2"
        >
        <el-col
            :lg="6"
            :sm="12"
            :xs="24"
            v-for="metric in repsStats.keys()"
            :key="metric"
            class="mb-2"
          >
            <div
              class="statistic-card patient-stats background-container"
            >
              <el-statistic
                :value="formatValue(repsStats.get(metric).mostRecentValue)"
              >
                <template #title>
                  <div
                    style="
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                    "
                  >
                    <span class="small-text">{{ metric }} Reps</span>
                    <span
                      class="small-text"
                      :class="{'red': isPositive(repsStats.get(metric).changePercentage), 'green': !isPositive(repsStats.get(metric).changePercentage)}"
                    >
                      {{ repsStats.get(metric).changePercentage }}
                      <el-icon>
                        <template
                          v-if="isPositive(repsStats.get(metric).changePercentage)"
                        >
                          <CaretTop />
                        </template>
                        <template v-else>
                          <CaretBottom />
                        </template>
                      </el-icon>
                    </span>
                  </div>
                </template>
              </el-statistic>
            </div>
          </el-col>
        </el-row>
      <div v-if="userDeviceTypes.has('Glove')">
        <div class="metric-text mb-1" :span="24">
          <span class="group-name">Glove</span>
        </div>
        <el-row
          :gutter="16"
          class="mb-2"
          v-for="side in gloveStats.keys()"
          :key="side"
        >
          <el-col
            :lg="6"
            :sm="12"
            :xs="24"
            v-for="(value, metric) in gloveStats.get(side)"
            :key="metric"
            class="mb-2"
          >
            <div
              class="statistic-card patient-stats background-container"
              :class="{'pastel-blue': side === 'left', 'pastel-orange': side === 'right'}"
            >
              <el-statistic
                :value="formatValue(gloveStats.get(side)[metric].mostRecentValue)"
              >
                <template #title>
                  <div
                    style="
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                    "
                  >
                    <span class="small-text">{{ metric }} - {{ side }}</span>
                    <span
                      class="small-text"
                      :class="{'red': isPositive(gloveStats.get(side)[metric].changePercentage), 'green': !isPositive(gloveStats.get(side)[metric].changePercentage)}"
                    >
                      {{ gloveStats.get(side)[metric].changePercentage }}
                      <el-icon>
                        <template
                          v-if="isPositive(gloveStats.get(side)[metric].changePercentage)"
                        >
                          <CaretTop />
                        </template>
                        <template v-else>
                          <CaretBottom />
                        </template>
                      </el-icon>
                    </span>
                  </div>
                </template>
              </el-statistic>
            </div>
          </el-col>
        </el-row>
      </div>

      <div v-if="userDeviceTypes.has('Knee Sleeve')">
        <div class="metric-text mb-1" :span="24">
          <span class="group-name">Knee</span>
        </div>
        <el-row
          :gutter="16"
          class="mb-2"
          v-for="side in kneeSleeveStats.keys()"
          :key="side"
        >
          <el-col
            :lg="6"
            :sm="12"
            :xs="24"
            v-for="(value, metric) in kneeSleeveStats.get(side)"
            :key="metric"
            class="mb-2"
          >
            <div
              class="statistic-card patient-stats background-container"
              :class="{'pastel-blue': side === 'left', 'pastel-orange': side === 'right'}"
            >
              <el-statistic
                :value="formatValue(kneeSleeveStats.get(side)[metric].mostRecentValue)"
              >
                <template #title>
                  <div
                    style="
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                    "
                  >
                    <span class="small-text">{{ metric }} - {{ side }}</span>
                    <span
                      class="small-text"
                      :class="{'red': isPositive(kneeSleeveStats.get(side)[metric].changePercentage), 'green': !isPositive(kneeSleeveStats.get(side)[metric].changePercentage)}"
                    >
                      {{ kneeSleeveStats.get(side)[metric].changePercentage }}
                      <el-icon>
                        <template
                          v-if="isPositive(kneeSleeveStats.get(side)[metric].changePercentage)"
                        >
                          <CaretTop />
                        </template>
                        <template v-else>
                          <CaretBottom />
                        </template>
                      </el-icon>
                    </span>
                  </div>
                </template>
              </el-statistic>
            </div>
          </el-col>
        </el-row>
      </div>

      <div v-if="userDeviceTypes.has('Pants')">
        <div class="metric-text mb-1" :span="24">
          <span class="group-name">Pants</span>
        </div>
        <el-row
          :gutter="16"
          class="mb-2"
          v-for="side in pantsStats.keys()"
          :key="side"
        >
          <el-col
            :lg="6"
            :sm="12"
            :xs="24"
            v-for="(value, metric) in pantsStats.get(side)"
            :key="metric"
            class="mb-2"
          >
            <div
              class="statistic-card patient-stats background-container"
              :class="{'pastel-blue': side === 'left', 'pastel-orange': side === 'right'}"
            >
              <el-statistic
                :value="formatValue(pantsStats.get(side)[metric].mostRecentValue)"
              >
                <template #title>
                  <div
                    style="
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                    "
                  >
                    <span class="small-text">{{ metric }} - {{ side }}</span>
                    <span
                      class="small-text"
                      :class="{'red': isPositive(pantsStats.get(side)[metric].changePercentage), 'green': !isPositive(pantsStats.get(side)[metric].changePercentage)}"
                    >
                      {{ pantsStats.get(side)[metric].changePercentage }}
                      <el-icon>
                        <template
                          v-if="isPositive(pantsStats.get(side)[metric].changePercentage)"
                        >
                          <CaretTop />
                        </template>
                        <template v-else>
                          <CaretBottom />
                        </template>
                      </el-icon>
                    </span>
                  </div>
                </template>
              </el-statistic>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue'
import getPatientStats from '../composables/getPatientStats'

export default {
  name: 'PatientStats',
  props: ['uid'],
  setup (props, { emit }) {
    const { getStats, TimeRange, repsStats, gloveStats, kneeSleeveStats, pantsStats, userDeviceTypes } = getPatientStats()

    onMounted(() => {
      getStats(props.uid, TimeRange.ONE_WEEK)
    })

    const formatValue = (value) => {
      return Number(value).toFixed(2)
    }

    const isPositive = (percentage) => {
      return !percentage.startsWith('-') // Check if the percentage is positive
    }

    const sliderValue = ref(0)

    const marks = ref({
      0: 'Last Week',
      33.33: 'Last Month',
      66.66: 'Last 6 Months',
      99.99: 'Last Half Year'
    })

    const onTimeRangeSelected = (value) => {
      switch (value) {
        case 0:
          getStats(props.uid, TimeRange.ONE_WEEK)
          break
        case 33.33:
          getStats(props.uid, TimeRange.ONE_MONTH)
          break
        case 66.66:
          getStats(props.uid, TimeRange.HALF_YEAR)
          break
        case 99.99:
          getStats(props.uid, TimeRange.ONE_YEAR)
          break
      }
    }
    return {
      gloveStats,
      kneeSleeveStats,
      pantsStats,
      formatValue,
      isPositive,
      marks,
      sliderValue,
      onTimeRangeSelected,
      repsStats,
      userDeviceTypes
    }
  }
}
</script>

<style scoped>
.statistic-card {
  height: 100%;
  padding: 10px;
  border-radius: 4px;
  background-color: var(--el-bg-color-overlay);
}

.statistic-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  font-size: 12px;
  color: var(--el-text-color-regular);
  margin-top: 16px;
}

.statistic-footer .footer-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.statistic-footer .footer-item span:last-child {
  display: inline-flex;
  align-items: center;
  margin-left: 4px;
}

.green {
  color: green;
}
.red {
  color: var(--el-color-error);
}

.half-width {
  width: 50%;
  height: 90%;
}

.small-text {
  font-size: 13px;
}

.metric-text {
  font-size: 13px;
  font-weight: 500;
}
</style>

<style>
.patient-stats .el-statistic__head {
  overflow-wrap: anywhere;
}

.patient-stats.el-statistic {
  font-size: 13px !important;
}

.patient-stats .statistic-footer {
  margin-top: 5px !important;
}

.pastel-blue {
  background-color: var(--pastel-blue) !important; /* Light blue */
}

.pastel-orange {
  background-color: var(--pastel-orange) !important; /* Light green */
}

.background-2 {
  background-color: #faeee0 !important;
}

.patient-stats .el-statistic__head {
  display: flex;
  flex-direction: column;
}

.el-slider__marks-text {
  font-size: 12px !important;
}

.el-slider {
  width: 70% !important;
  margin-left: auto;
}

.el-slider__marks-text {
  transform: translateX(-100%) !important;
}

.el-slider__bar {
  background-color: var(--accent-color) !important;
}

.el-slider__button {
  border: 2px solid var(--accent-color) !important;
  height: 15px !important;
  width: 15px !important;
}

.el-slider__stop {
  background-color: var(--accent-color) !important;
}

.el-slider__runway {
  background-color: var(--border-color) !important;
}

.stats-container {
  height: 450px;
  overflow: hidden;
  padding-right: 10px;
}

.content-container {
  overflow-y: auto;
  height: calc(100% - 60px);
  padding-right: 10px;
}
</style>
